module.exports = __webpack_public_path__ + "img/caminhao.c4d8b56a.jpg";